export default __webpack_public_path__ + "static/media/moi-sme-logo.a7d40357.png";